import { render, staticRenderFns } from "./EquipoComentarioWebApp.vue?vue&type=template&id=c3703138&"
import script from "./EquipoComentarioWebApp.vue?vue&type=script&lang=js&"
export * from "./EquipoComentarioWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports